export default "__VITE_ASSET__8e19289a__$_?component__"